"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const User_1 = require("../User");
class ModificationRequestIssueComment {
    constructor({ id, body, user, assetIds, createdAt, }) {
        this.toJSON = () => ({
            id: this.id,
            body: this.body,
            user: this.user,
            assetIds: this.assetIds.toJSON(),
            createdAt: this.createdAt.toISO(),
        });
        this.id = id;
        this.body = body;
        this.user = user;
        this.assetIds = assetIds;
        this.createdAt = createdAt;
    }
}
ModificationRequestIssueComment.fromJSON = (json) => {
    const { id, body, user, assetIds, createdAt } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof body !== 'string')
        throw new Error('.body must be a string');
    if (!Array.isArray(assetIds))
        throw new Error('.assetIds must be an array');
    // FIXME: DateTime型で受け取るとバリデーションに引っかかる
    if (typeof createdAt !== 'string')
        throw new Error('.createdAt must be a string');
    return new ModificationRequestIssueComment({
        id,
        body,
        user: User_1.DirectorUser.fromJSON(user),
        assetIds: immutable_1.List(assetIds),
        createdAt: luxon_1.DateTime.fromISO(createdAt),
    });
};
exports.default = ModificationRequestIssueComment;
